import React from 'react';

const AbonementPage: React.FC = () => {
  return <div>Für Theorieprüfung online lernen</div>;
};

export default AbonementPage;
